/* unplugin-vue-components disabled */import script from "./AppMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=f3097b52&lang=scss&scoped=true"
import "./AppMain.vue?vue&type=style&index=1&id=f3097b52&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3097b52"]])

export default __exports__